import SectionFeaturedService from './SectionFeaturedService';

export default SectionFeaturedService;
